export const ADMIN = "admin"
export const CONSULTANT = "consultation"
export const COMPLET = "complet"